import { ReactElement } from 'react';

import { Lineup, Movie, MovieDate } from '../types';

export default function MovieComponent({ movie }: { movie: Movie }): ReactElement {
  return (
    <div className="col">
      <div className="card">
        {movie.imageUrl != null && <img className="card-img-top bg-black" width="100%" height="auto" loading="lazy" src={movie.imageUrl} alt={movie.title} />}
        <div className="card-body">
          <h2 className="card-title"><a href={movie.websiteUrl} target="_blank" rel="noopener noreferrer">{movie.title}</a></h2>
          <div className="card-text">
            {movie.dates.length > 0 && (
            <div>
              <strong>Wann und wo:</strong>
              {movie.dates.map((date: MovieDate) => (
                <span key={date.datetime + date.venue}>
                  <br />
                  {date.stringified}
                </span>
              ))}
            </div>
            )}
            {movie.lineups.map((lineup: Lineup) => (
              <div key={lineup.key}>
                <strong>Mit dabei im Programm{ movie.lineups.length > 1 && <span> {lineup.date.stringified}</span> }:</strong>
                <ul className="lineup">
                  {lineup.movies.map((m) => (
                    <li key={m.websiteUrl} style={{ fontWeight: (m === movie) ? 'bold' : undefined }}>
                      <a href={m.websiteUrl} target="_blank" rel="noopener noreferrer">{m.title}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            {movie.category != null && <div><strong>Kategorie:</strong> {movie.category}</div>}
            {movie.section != null && <div><strong>Rubrik:</strong> {movie.section}</div>}
            {movie.detailsStringified != null && <div><strong>Details:</strong> {movie.detailsStringified}</div>}
            {movie.descriptionShort && (
            <details open>
              <summary><strong>Kurzbeschreibung</strong></summary>
              {movie.descriptionShort}
            </details>
            )}
            {movie.description && (
            <details>
              <summary><strong>Beschreibung</strong></summary>
              {movie.description}
            </details>
            )}
            {movie.people.length > 0 && (
            <details>
              <summary><strong>Team</strong></summary>
              <ul>{movie.people.map((person: string) => (
                <li key={person}>{person}</li>))}
              </ul>
            </details>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
